<template>
  <header class="vz-header">
    <div class="vz-header-content">
      <nuxt-link class="vz-logo" to="/" aria-label="Início">
        <strong>{{ $store.state.config.title || 'Vizzto' }}</strong>
      </nuxt-link>
      <div
        v-if="environment === 'uat' || environment === 'dev'"
        :class="{
          'tag-environment-dev': environment === 'dev',
          'tag-environment-uat': environment === 'uat'
        }"
      >
        {{
          environment === 'dev'
            ? 'desenvolvimento'
            : environment === 'uat'
            ? 'homologação'
            : ''
        }}
      </div>
      <transition name="vz-t-fade" mode="out-in">
        <vz-app-menu
          class="vz-header-menu"
          v-if="$store.state.ui.navigation.state === 'ready'"
          :class="{ 'vz-open': open === 'app-menu' }"
          :items="$store.state.ui.navigation.main"
          @open="setOpen('app-menu')"
        >
        </vz-app-menu>
        <div class="vz-loading-menu" v-else>
          <i class="ic-loader vz-spin"></i>
        </div>
      </transition>
      <vz-search
        class="vz-header-search"
        placeholder="Buscar..."
        :class="{ 'vz-open': open === 'search' }"
        @open="setOpen('search')"
        @search="triggerSearch"
      >
      </vz-search>
      <transition name="vz-t-fade" mode="out-in">
        <vz-user-menu
          class="vz-header-user-menu"
          v-if="$store.state.ui.navigation.state === 'ready'"
          :class="{ 'vz-open': open === 'user-menu' }"
          :user-name="$store.state.user.user.name"
          :items="$store.state.ui.navigation.user"
          @open="setOpen('user-menu')"
        >
        </vz-user-menu>
        <div class="vz-loading-user" v-else>
          <i class="ic-loader vz-spin"></i>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
import VzSearch from 'vsp-web-ui-lib/components/molecules/vz-search-field.vue';
import VzUserMenu from '../molecules/user-menu.vue';
import VzAppMenu from '../molecules/app-menu.vue';

export default {
  name: 'Header',
  components: {
    VzAppMenu,
    VzSearch,
    VzUserMenu
  },

  data: () => ({
    open: null,
    environment: process.env.mode
  }),

  methods: {
    setOpen(value) {
      this.open = value;
    },

    triggerSearch(terms) {
      this.$router.push(`/search/${encodeURIComponent(terms)}`);
    }
  }
};
</script>

<style scoped>
.tag-environment-dev,
.tag-environment-uat {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
  background-color: red;
  color: white;
}

.tag-environment-uat {
  background-color: #e05a00;
}

@media (max-width: 1024px) {
  .vz-header-content {
    flex-direction: column;
    align-items: center;
  }

  .tag-environment-dev,
  .tag-environment-uat {
    margin-left: 210px;
    margin-top: 10px;
  }
}
</style>

<style theme="dark-theater" scoped>
@keyframes header-slide-down {
  100% {
    top: 0;
  }
}

.vz-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 56px;
  background: var(--header-home-background);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.57);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  z-index: 100;
}

.vz-logo,
.vz-header-menu,
.vz-header-search,
.vz-header-user-menu,
.vz-loading-menu,
.vz-loading-user {
  position: absolute;
}

.vz-logo {
  top: 50%;
  left: 56px;
  width: 180px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  background-image: var(--logo-top-bar);
  transform: translate(0, -50%);
  border-bottom-width: 0;
}

.vz-logo strong {
  display: none;
}

.vz-header-menu,
.vz-loading-menu {
  top: 16px;
  left: 16px;
}

.vz-header-user-menu,
.vz-loading-user {
  top: 14px;
  right: 16px;
}

.vz-loading-menu,
.vz-loading-user {
  width: 26px;
  height: 26px;
}

.vz-loading-menu .ic-loader,
.vz-loading-user .ic-loader {
  color: #8d8c8c;
  font-size: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
}

.vz-header-search {
  top: 16px;
  right: 64px;
}

.vz-open {
  z-index: 100;
}

@media (min-width: 1024px) {
  .vz-header {
    top: -104px;
    min-height: 96px;
    animation-name: header-slide-down;
    animation-duration: 0.4s;
    animation-fill-mode: forwards;
    animation-delay: 0.5s;
  }

  .vz-header-content {
    position: relative;
    min-height: 96px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 36px 0 330px;
    margin: 0;
    width: 100%;
  }

  .vz-logo {
    left: 104px;
  }

  .vz-header-menu,
  .vz-loading-menu {
    top: 39px;
    left: 36px;
  }

  .vz-header-search,
  .vz-header-user-menu,
  .vz-loading-user {
    position: relative;
    top: auto;
    right: auto;
  }

  .vz-header-search {
    width: 100%;
  }

  .vz-header-user-menu,
  .vz-loading-user {
    margin-left: 36px;
  }
}
</style>






































































































































